import { AppThemePreset } from './app-theme-preset';
import { PrimeNGConfigType } from 'primeng/config';

export const primeNGConfig: PrimeNGConfigType = {
  theme: {
    preset: AppThemePreset,
    options: {
      darkModeSelector: 'none',
    },
  },
  ripple: true,
};
